<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <div class="page-title-box d-sm-flex align-items-center justify-content-between">
        <h4 class="mb-sm-0">SAP Categories Management</h4>
        <div class="page-title-right">
          <ol class="breadcrumb m-0">
            <li class="breadcrumb-item"><a routerLink="/dashboard">Menu</a></li>
            <li class="breadcrumb-item active">SAP Categories</li>
          </ol>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-xl-12">
      <div class="card">
        <div class="card-header align-items-center d-flex">
          <h4 class="card-title mb-0 flex-grow-1">SAP Categories</h4>
          <div class="flex-shrink-0">
            <a routerLink="/ecomm/sap-categories/add" class="btn btn-primary waves-effect waves-light">Add SAP Category</a>
          </div>
        </div>
        <div class="card-body">
          <div class="live-preview">
            <div class="table-responsive table-card">
              <table class="table align-middle table-nowrap mb-0">
                <thead class="table-light">
                  <tr>
                    <th scope="col">Name</th>
                    <th scope="col">SAP Category ID</th>
                    <th scope="col">Status</th>
                    <th scope="col">Created Date</th>
                    <th scope="col" style="width: 150px;">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of items | paginate: paginationConfig">
                    <td>{{ item.name }}</td>
                    <td>{{ item.sap_category_id ?? '-' }}</td>
                    <td>
                      <app-badge-status [statusLabel]="statusLabel(item.status)" />
                    </td>
                    <td>{{ item.created_at | date:'dd/MM/yyyy' }}</td>
                    <td>
                      <a [routerLink]="['/ecomm/sap-categories', item.id]" class="btn btn-sm btn-light">View</a>
                    </td>
                  </tr>
                  <tr *ngIf="items.length === 0">
                    <td colspan="5" class="text-center text-muted py-4">No SAP categories found.</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="text-end mt-4" *ngIf="(paginationConfig?.totalItems ?? 0) > 0">
              <pagination-controls
                id="{{ paginationConfig.id }}"
                (pageChange)="onPageChange($event)"
                previousLabel="Previous"
                nextLabel="Next">
              </pagination-controls>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
